export class PrivacyPolicy{
    constructor(data){
        this.id = data.id;
        this.upperTitle = data.upperTitle;
        this.upperTitle_eng = data.upperTitle_eng;
        this.body = data.body;
    }
}